import React, { useEffect, useState } from "react";
import { FiClock, FiX } from "react-icons/fi";
import { isServerClockReady, refreshServerClock, serverNow } from "../utils/serverClock";
import "./device-clock-notice.css";

export default function DeviceClockNotice() {
  const [wrong, setWrong] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return undefined;
    let active = true;
    let checking = false;
    let confirmed = false;
    let lastConfirmation = -Infinity;
    const mismatch = () => isServerClockReady() && Math.abs(Date.now() - serverNow()) > 300000;
    const check = async () => {
      if (document.visibilityState === "hidden" || !navigator.onLine || !mismatch()) {
        confirmed = false;
        setWrong(false);
        return;
      }
      if (checking) return;
      if (performance.now() - lastConfirmation < 300000) {
        setWrong(confirmed);
        return;
      }
      checking = true;
      lastConfirmation = performance.now();
      try {
        // Shared with existing clock refreshes; no extra polling for normal clocks.
        const refreshed = await refreshServerClock();
        if (!active) return;
        confirmed = Boolean(refreshed && document.visibilityState !== "hidden"
          && navigator.onLine && mismatch());
        setWrong(confirmed);
      } catch (_) {
        if (active) { confirmed = false; setWrong(false); }
      } finally { checking = false; }
    };
    check();
    const timer = window.setInterval(check, 15000);
    const hide = () => { confirmed = false; setWrong(false); };
    document.addEventListener("visibilitychange", hide);
    window.addEventListener("offline", hide);
    return () => {
      active = false;
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", hide);
      window.removeEventListener("offline", hide);
    };
  }, [dismissed]);
  if (!wrong || dismissed) return null;
  return <aside className="device-clock-notice" role="status" dir="rtl">
    <FiClock aria-hidden="true" />
    <span>ساعت دستگاه با سرور هماهنگ نیست. زمان‌بندی برنامه بر اساس ساعت سرور است؛ لطفاً تنظیم خودکار تاریخ و ساعت دستگاه را روشن کنید.</span>
    <button type="button" aria-label="بستن هشدار ساعت دستگاه" onClick={() => setDismissed(true)}><FiX /></button>
  </aside>;
}
